module.exports = __webpack_public_path__ + "static/media/ODS3.fe35283c.jpeg";